import {
  AutocompleteArrayInput,
  Button,
  ReferenceArrayInput,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { accountRequests } from "api/accountApi";

const EditRolesDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) return null;

  const handleConfirm = async ({ roleIds }) => {
    await dataProvider.customRequest(accountRequests.updatePermissionRoles(record.id), { roleIds }, "PUT");
    notify("Ролите са обновени успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      onConfirm={handleConfirm}
      titleContent={`Роли за право „${record.name}“`}
      dialogSize="md"
      defaultValues={{ roleIds: record.roles?.map(role => role.id) ?? [] }}
      triggerButton={
        <Button
          startIcon={<EditIcon />}
          label="Промени"
        />
      }
    >
      <ReferenceArrayInput
        source="roleIds"
        reference={accountRequests.getRolesSelect()}
      >
        <AutocompleteArrayInput
          optionText="name"
          label="Роли"
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          fullWidth
        />
      </ReferenceArrayInput>
    </FormModal>
  );
};

export default EditRolesDialog;
